import React from 'react'
import classNames from 'classnames'
import { node, oneOfType, string, object, array } from 'prop-types'

const Table = ({ children, className }) => (
  <table
    style={{ borderCollapse: 'collapse' }}
    className={classNames('sw-table', 'w-full', className)}
  >
    {children}
  </table>
)

Table.displayName = 'Table'

Table.propTypes = {
  /** Component's children */
  children: node,
  /** Custom className */
  className: oneOfType([string, object, array])
}

export default Table
